<template>
  <section>
    <b-dropdown
      aria-role="list"
      class="local-lm-filters local-lm-fix--min-width"
      v-model="selectedOption"
      @active-change="sort"
    >
      <button
        class="button"
        type="button"
        slot="trigger"
      >
        <div class="local-lm-filters--placeholder">
          <template>
            <span
              v-if="!selectedOption"
              v-t="$t('OrderTableFilter.title')"
            />
            <span
              v-if="selectedOption"
              v-t="$t(`OrderTableFilter.${selectedOption}`).toUpperCase()"
            />
          </template>
          <b-icon
            icon="chevron-down"
          />
        </div>
      </button>
      <b-dropdown-item
        v-for="(orderedFilter, index) in orderedFilters"
        :key="index"
        :value="orderedFilter"
      >
        {{ $t(`OrderTableFilter.${orderedFilter}`) | upperCase }}
      </b-dropdown-item>
    </b-dropdown>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrderTableFilter',
  props: ['type'],
  beforeDestroy () {
    this.$eventBus.$off('onPageChange', this.page)
  },
  computed: {
    ...mapGetters('filters', [
      'orderedFilters'
    ])
  },
  mounted () {
    this.$store.dispatch('filters/getFilters', this.type)
    this.$eventBus.$on('onPageChange', this.page)

    this.$eventBus.$on('cleanFilters', () => {
      this.selectedOption = null
    })
  },
  data () {
    return {
      selectedOption: null
    }
  },
  methods: {
    sort () {
      if (!this.selectedOption) return

      const filters = this.$store.getters['filters/filtersSelected']

      if (!filters || (filters && filters.sortOption !== this.selectedOption)) {
        this.$store.dispatch('filters/setSort', this.selectedOption)
        this.$eventBus.$emit('sortOrders', this.selectedOption)
      }
    },
    page (page) {
      this.$store.dispatch('filters/setPage', page)
      this.$eventBus.$emit('pageOrders', page)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/OrderTableFilter.vue